export default function triggerPresignedDownload(
  url: string,
  downloadFilename?: string,
): void {
  const anchor = document.createElement('a')
  anchor.href = url
  if (downloadFilename) {
    anchor.download = downloadFilename
  }
  anchor.target = '_blank'
  anchor.rel = 'noopener noreferrer'
  anchor.click()
}
